import React from "react";
import {
  CodeIcon,
  BankIcon,
  GamepadIcon,
  CartIcon,
  HeartIcon,
  WrenchIcon,
  SignalIcon,
  LockIcon,
  ChartIcon,
  RocketIcon,
} from "./Icons";
import "./Industries.css";

const industries = [
  { icon: <CodeIcon size={32} />, name: "IT & Software" },
  { icon: <BankIcon size={32} />, name: "Fintech & Banking" },
  { icon: <GamepadIcon size={32} />, name: "GameDev" },
  { icon: <CartIcon size={32} />, name: "E-commerce" },
  { icon: <HeartIcon size={32} />, name: "Healthcare" },
  { icon: <WrenchIcon size={32} />, name: "Engineering" },
  { icon: <SignalIcon size={32} />, name: "Telecom" },
  { icon: <LockIcon size={32} />, name: "Cybersecurity" },
  { icon: <ChartIcon size={32} />, name: "Data & Analytics" },
  { icon: <RocketIcon size={32} />, name: "Startups" },
];

const Industries: React.FC = () => {
  return (
    <section className="industries">
      <div className="industries__container">
        <div className="industries__header">
          <span className="industries__tag">Industries</span>
          <h2 className="industries__title">
            Areas We
            <br />
            <span className="industries__title--accent">Know Well</span>
          </h2>
          <p className="industries__subtitle">
            We recruit across these fields and always expanding.
          </p>
        </div>
        <div className="industries__grid">
          {industries.map((item, i) => (
            <div className="industries__card" key={i}>
              <span className="industries__card-icon">{item.icon}</span>
              <span className="industries__card-name">{item.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
